<template>
  <div id="data-list-list-view" class="data-list-container">
    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <new
        :isSidebarActive="newSidebar"
        :products="products"
        @closeSidebar="toggleNewSidebar"
        @add="addDataSideBar"
        :data="sidebarData"/>
    <update
        :isSidebarActive="updateSidebar"
        :products="products"
        @closeSidebar="toggleUpdateSidebar"
        @update="updateDataSideBar"
        :data="sidebarData"/>

    <!-- Video popup -->
    <div v-if="videoPopup" class="video-popup-overlay" @click.self="closeVideoPopup">
      <div class="video-popup-content">
        <div class="flex items-center justify-between mb-4">
          <h4 class="text-white">{{ videoPopupData ? videoPopupData.title : '' }}</h4>
          <feather-icon icon="XIcon" @click="closeVideoPopup" class="cursor-pointer text-white" svgClasses="w-6 h-6"/>
        </div>
        <div class="rounded-lg overflow-hidden" style="position: relative; padding-top: 56.25%; background: #000;">
          <video v-if="videoPopupData" ref="videoPlayer" controls
                 :poster="`https://image.mux.com/${videoPopupData.muxPlaybackId}/thumbnail.jpg?width=800`"
                 style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
          </video>
        </div>
      </div>
    </div>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="list">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- Action - dropnow -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4">
            <div
                class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="editData(selected)">
                            <span class="flex items-center">
                              <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                              <span>Editar</span>
                            </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!-- Add new -->
          <vs-button :disabled="initProgress" color="danger" type="border" class="mr-6" @click="addNewData">
            Agregar
          </vs-button>
        </div>

        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ list.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : list.length }} de {{
                queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Preview</vs-th>
        <vs-th sort-key="title">Título</vs-th>
        <vs-th sort-key="description">Descripción</vs-th>
        <vs-th>Productos</vs-th>
        <vs-th>Estado</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div v-if="tr.muxPlaybackId" class="video-thumb-container" style="position: relative; cursor: pointer;"
                 @click.stop="openVideoPopup(tr)">
              <img :src="`https://image.mux.com/${tr.muxPlaybackId}/thumbnail.jpg?width=120&height=120&fit_mode=smartcrop`"
                   alt="video thumb" class="rounded-lg"
                   style="width: 60px; height: 60px; object-fit: cover;">
              <div class="flex items-center justify-center" style="position: absolute; top: 0; left: 0; width: 60px; height: 60px; background: rgba(0,0,0,0.3); border-radius: 0.5rem;">
                <feather-icon icon="PlayIcon" svgClasses="w-5 h-5 text-white"/>
              </div>
            </div>
            <span v-else class="text-grey text-sm">—</span>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.title }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name truncate" style="max-width: 250px;">{{ tr.description }}</p>
          </vs-td>

          <vs-td>
            <vs-chip v-if="tr.associatedProducts" color="primary">
              {{ tr.associatedProducts.length }}
            </vs-chip>
            <span v-else>0</span>
          </vs-td>

          <vs-td>
            <vs-switch @input="switchState(tr)" v-model="tr.state"/>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current mr-2"
                          @click.stop="editData(tr)"/>
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          @click.stop="confirmDelete(tr)"/>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import New from './New'
import Update from './Update'

import { db } from '@/firebase/firebaseConfig'

export default {
  name: 'PostsList',
  components: {
    New,
    Update
  },
  data () {
    return {
      itemsPerPage: 20,
      isMounted: false,
      list: [],
      products: [],
      initProgress: false,
      selected: null,
      filter: false,

      // Data Sidebar
      newSidebar: false,
      updateSidebar: false,
      sidebarData: {},

      // Video popup
      videoPopup: false,
      videoPopupData: null,
      hlsInstance: null
    }
  },
  async created () {
    try {
      this.initProgress = true
      await Promise.all([
        this.loadPosts(),
        this.loadProducts()
      ])
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  mounted () {
    this.isMounted = true
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.list.length
    },
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.newSidebar = true
    },
    editData (data) {
      if (data) {
        this.sidebarData = data
        this.toggleUpdateSidebar(true)
      }
    },
    openVideoPopup (data) {
      if (!data.muxPlaybackId) return
      this.videoPopupData = data
      this.videoPopup = true
      this.$nextTick(() => {
        this.initVideoPlayer(data.muxPlaybackId)
      })
    },
    initVideoPlayer (playbackId) {
      const video = this.$refs.videoPlayer
      if (!video) return
      const src = `https://stream.mux.com/${playbackId}.m3u8`

      // Safari supports HLS natively
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = src
        video.play()
        return
      }

      // Load hls.js for other browsers
      if (window.Hls) {
        this.attachHls(video, src)
        return
      }

      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1'
      script.onload = () => {
        this.attachHls(video, src)
      }
      document.head.appendChild(script)
    },
    attachHls (video, src) {
      if (this.hlsInstance) {
        this.hlsInstance.destroy()
      }
      if (window.Hls && window.Hls.isSupported()) {
        const hls = new window.Hls()
        hls.loadSource(src)
        hls.attachMedia(video)
        hls.on(window.Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
        this.hlsInstance = hls
      }
    },
    closeVideoPopup () {
      if (this.hlsInstance) {
        this.hlsInstance.destroy()
        this.hlsInstance = null
      }
      const video = this.$refs.videoPlayer
      if (video) {
        video.pause()
        video.removeAttribute('src')
      }
      this.videoPopup = false
      this.videoPopupData = null
    },
    toggleNewSidebar (val = false) {
      this.newSidebar = val
    },
    toggleUpdateSidebar (val = false) {
      this.updateSidebar = val
    },
    async switchState (object) {
      try {
        await db.collection('posts').doc(object.id).update({
          state: object.state
        })

        this.$vs.notify({
          color: 'success',
          title: 'Posts',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    async confirmDelete (post) {
      try {
        await db.collection('posts').doc(post.id).delete()
        const index = this.list.findIndex((d) => d.id === post.id)
        this.list.splice(index, 1)
        this.$vs.notify({
          color: 'success',
          title: 'Posts',
          text: 'Post eliminado correctamente.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    async loadPosts () {
      const querySnapshot = await db.collection('posts')
          .orderBy('createdAt', 'desc')
          .get()
      querySnapshot.forEach((doc) => {
        let obj = {
          id: doc.id,
          ...doc.data(),
          createdAt: doc.data().createdAt ? doc.data().createdAt.toDate() : new Date()
        }
        this.list.push(obj)
      })
    },
    async loadProducts () {
      const querySnapshot = await db.collection('products')
          .orderBy('createdAt', 'desc')
          .get()
      querySnapshot.forEach((doc) => {
        this.products.push({
          id: doc.id,
          name: doc.data().name,
          sku: doc.data().sku,
          slug: doc.data().slug || null,
          categorySlug: doc.data().category ? doc.data().category.slug : null,
          image1: doc.data().image1 || null,
          label: doc.data().name + ' - ' + doc.data().sku
        })
      })
    },
    addDataSideBar (o) {
      this.list.unshift(o)
    },
    updateDataSideBar (o) {
      const index = this.list.findIndex((d) => d.id === o.id)
      Object.assign(this.list[index], o)
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.video-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  z-index: 52020;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-popup-content {
  width: 90%;
  max-width: 800px;
}
</style>
